import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=48413994&scoped=true"
import script from "./CommentComponent.vue?vue&type=script&lang=js"
export * from "./CommentComponent.vue?vue&type=script&lang=js"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=48413994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.2__lodash@4_9acdcff83b5891d2d7c120609da332e7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48413994",
  null
  
)

export default component.exports